import React from 'react';
import { blogs } from '../data/blogs';
import { poems } from '../data/poems';
import '../App.css';

export default function HomePage() {
  const heroImage = `${process.env.PUBLIC_URL || ''}/images/home/home-hero.JPG`;
  return (
    <>
      <main className="home">
        <div className="container hero">
          <div className="hero-header">
            <h1 className="hero-title" aria-label="Ben Chesser">
              <svg className="hero-wordmark" viewBox="0 0 1100 148" aria-hidden="true" focusable="false">
                <text className="hero-wordmark-name" x="14" y="114" textLength="1065" lengthAdjust="spacingAndGlyphs">
                  BEN CHESSER
                </text>
                <text className="hero-wordmark-signature" x="1090" y="139" textAnchor="end" textLength="275" lengthAdjust="spacingAndGlyphs">
                  wbenchesser
                </text>
              </svg>
            </h1>
          </div>
          <div className="home-wave home-wave-hero">
          <div
            className="hero-media"
            style={{ backgroundImage: `url("${heroImage}")` }}
            role="img"
          >
          </div>
          </div>
        </div>

        <div className="container">
          <section className="section">
            <h2>Hi there!</h2>
            <p>In case you don't know me, I'm Ben!</p>
            <p>
              I graduated from the University of North Carolina at Chapel Hill in May 2026 with a BS in Computer 
              Science and a minor in Creative Writing.
            </p>
            <p>
              I now work as a software engineer on the Emerging Technologies team at Red Hat, where I started in June 2026.
            </p>
            <p>
              In the Summer of 2025 I was a software engineering intern at Apple in Austin, Texas.
            </p>
            <p>
              I was a teaching assistant for UNC's Computer Organization (COMP 311)
              and Systems Fundamentals (COMP 211) courses, and won the <a href="https://cs.unc.edu/about/awards/department-awards/pozefsky-la-award/" target="_blank" rel="noreferrer">Diane Pozefsky Learning Assistant Award</a> at my graduation.
              I also led the <a href="https://csxl.unc.edu/welcome" target="_blank" rel="noreferrer">Computer Science Experience Labs</a> (CSXL) as the staff manager for four semesters.
            </p>
            <p>
              I am an advisor and a previous CEO of <a href="https://appteamcarolina.com" target="_blank" rel="noreferrer">App Team Carolina</a>, a nonprofit
              student organization that primarily teaches mobile development and makes production-level
              apps including ones for other nonprofits like <a href="https://porchcommunities.org" target="_blank" rel="noreferrer">PORCH</a> and startup apps like <a href="https://centible.app" target="_blank" rel="noreferrer">Centible</a>.
            </p>
            <p>
              I recently started learning guitar and love indie and rock music. My favorite artists include Peach Pit, The Beatles, and Malcolm Todd. I also spend a lot of time reading. Lately, I've been focused on the epic 
              fantasy series <i>The Stormlight Archive.</i> In addition, I'm currently training for a half marathon, and 
              always appreciate recommendations for good running routes.
            </p>
            <p>
              You can view my resume <a href="/ben-chesser-resume.pdf" target="_blank" rel="noreferrer">here</a>.
            </p>
          </section>

          <section className="section">
            <h2>Blog and Other Writing</h2>
            <p>
              My assorted thoughts.
              None of it is generative AI, I promise. As I write, I'll post and update here.
            </p>
            <h3 className="home-subtitle">Recent Blog Posts</h3>
            <div className="home-list-grid home-wave home-wave-blog">
              {blogs.slice(0, 3).map((b) => (
                <a key={b.id} className="blog-card" href={`#/blog/${b.id}`}>
                  <div className="blog-card-inner">
                    <h3 className="blog-title">{b.title}</h3>
                    <div className="blog-meta">{b.date}</div>
                    <p className="blog-blurb">{b.blurb}</p>
                  </div>
                </a>
              ))}
            </div>
            <p className="read-more"><a href="#/blog">Read all blog posts →</a></p>
          </section>

          <section className='section'>
            <p>
              Some of you may know I was a creative writing minor. I don't know how, it's not like I mention it.
              If it's a poem, it may be a bit sappy, so be prepared for that. Here's some of my work.
            </p>
            <h3 className="home-subtitle">Recent Poems</h3>
            <div className="home-list-grid home-wave home-wave-poems">
              {poems.slice(0, 3).map((p) => (
                <a key={p.id} className="poem-card" href={`#/poetry/${p.id}`}>
                  <div className="poem-card-inner">
                    <h3 className="poem-title">{p.title}</h3>
                    <div className="poem-meta">{p.date}</div>
                  </div>
                </a>
              ))}
            </div>
            <p><a href="#/poetry">Read all poems →</a></p>
          </section>
        </div>
      </main>
      <footer className="home-footer">
        <div className="container home-footer-inner">
          <span>© {new Date().getFullYear()} Ben Chesser</span>
          <span>Made with <span className="home-footer-heart" role="img" aria-label="love">♥</span></span>
        </div>
      </footer>
    </>
  );
}
